
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcTranTypeDialog extends Serenity.EntityDialog<IcTranTypeRow, any> {
        protected getFormKey() { return IcTranTypeForm.formKey; }
        protected getIdProperty() { return IcTranTypeRow.idProperty; }
        protected getLocalTextPrefix() { return IcTranTypeRow.localTextPrefix; }
        protected getNameProperty() { return IcTranTypeRow.nameProperty; }
        protected getService() { return IcTranTypeService.baseUrl; }
        protected getDeletePermission() { return IcTranTypeRow.deletePermission; }
        protected getInsertPermission() { return IcTranTypeRow.insertPermission; }
        protected getUpdatePermission() { return IcTranTypeRow.updatePermission; }

        protected form = new IcTranTypeForm(this.idPrefix);

    }
}